import React from 'react';
import { Link } from 'react-router-dom';
import { BOOKING_FLOW_ENABLED, CONTACT_PATH } from '../bookingConfig';
import { getServiceBookingLinks } from '../data/serviceBookingLinks';
import '../styles/ServiceBookingButtons.css';

type ServiceBookingButtonsProps = {
  serviceId: string;
  /** Card actions row — compact pills */
  variant?: 'card' | 'modal';
  className?: string;
};

const ServiceBookingButtons: React.FC<ServiceBookingButtonsProps> = ({
  serviceId,
  variant = 'card',
  className = '',
}) => {
  if (serviceId === 'speaking-engagements') {
    return (
      <div
        className={`i3-service-booking-buttons i3-service-booking-buttons--${variant} i3-service-booking-buttons--solo ${className}`.trim()}
        role="group"
        aria-label="Book a session"
      >
        <Link
          to={CONTACT_PATH}
          className={`i3-cta i3-cta-primary i3-service-book-btn i3-service-book-btn--${variant}`}
        >
          Contact to book
        </Link>
      </div>
    );
  }

  if (!BOOKING_FLOW_ENABLED) {
    return (
      <Link
        to={CONTACT_PATH}
        className={`i3-cta i3-cta-primary i3-service-book-btn i3-service-book-btn--${variant} ${className}`.trim()}
      >
        Contact to book
      </Link>
    );
  }

  const { virtual, inPerson } = getServiceBookingLinks(serviceId);
  const virtualUrl = virtual?.trim();
  const inPersonUrl = inPerson?.trim();

  if (!virtualUrl && !inPersonUrl) {
    return (
      <Link
        to={CONTACT_PATH}
        className={`i3-cta i3-cta-primary i3-service-book-btn i3-service-book-btn--${variant} ${className}`.trim()}
      >
        Contact to book
      </Link>
    );
  }

  return (
    <div
      className={`i3-service-booking-buttons i3-service-booking-buttons--${variant} ${className}`.trim()}
      role="group"
      aria-label="Book a session"
    >
      {virtualUrl ? (
        <a
          href={virtualUrl}
          className={`i3-cta i3-cta-primary i3-service-book-btn i3-service-book-btn--${variant}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          Virtual
        </a>
      ) : null}
      {inPersonUrl ? (
        <a
          href={inPersonUrl}
          className={`i3-cta i3-cta-primary i3-service-book-btn i3-service-book-btn--${variant}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          In-Person
        </a>
      ) : null}
    </div>
  );
};

export default ServiceBookingButtons;
